import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from '@xstyled/styled-components';
import { Space } from 'antd';
import { BaseQuestionGradingComponent, QuestionDescriptionComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { FillInBlankDescription, FillInBlankGradingAnswers, AnswerDetailsComponent } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAnswerGroup = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var FillInBlankGradingComponent = function FillInBlankGradingComponent(_ref) {
  var _states$isShowingScor;

  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var fillInBlankQuestion = question;
  var baseLabel = states.label,
      answers = states.answer,
      isSubmissionSubmitted = states.isSubmissionSubmitted,
      isShowingExplanation = states.isShowingExplanation,
      disabled = states.disabled,
      updatedBlankId = states.updatedBlankId;
  var submitGradeAnswer = actions.submitGradeAnswer;
  var label = {
    correctAnswer: baseLabel.correctAnswer,
    disabledScoreInputText: states.scoreInputDisabledText || baseLabel.disabledScoreInputText,
    score: baseLabel.score,
    invalidScore: baseLabel.invalidScore,
    colorStatusCorrect: baseLabel.colorStatusCorrect,
    colorStatusIncorrect: baseLabel.colorStatusIncorrect,
    colorStatusCustomGrade: baseLabel.colorStatusCustomGrade,
    colorStatusSkipped: baseLabel.skipped
  };
  return /*#__PURE__*/_jsx(BaseQuestionGradingComponent, {
    states: _objectSpread(_objectSpread({}, states), {}, {
      hasCustomDescription: true,
      isShowingScoreInput: false // Disable base score input

    }),
    actions: actions,
    children: /*#__PURE__*/_jsxs(StyledAnswerGroup, {
      direction: "vertical",
      size: "large",
      children: [/*#__PURE__*/_jsx(QuestionDescriptionComponent, {
        description: question.description,
        label: baseLabel,
        content: /*#__PURE__*/_jsx(FillInBlankDescription, {
          description: question.description,
          answers: answers,
          startQuestionIndex: question.index,
          question: fillInBlankQuestion,
          isShowCorrectAnswer: false,
          isSubmissionSubmitted: isSubmissionSubmitted,
          readOnly: true
        })
      }), /*#__PURE__*/_jsx(FillInBlankGradingAnswers, {
        fillInBlankQuestion: fillInBlankQuestion,
        fillInBlankGroupAnswer: answers,
        label: label,
        isSubmissionSubmitted: isSubmissionSubmitted,
        submitGradeAnswer: submitGradeAnswer,
        disabled: disabled,
        updatedAnswerId: updatedBlankId,
        isPreviewMode: false,
        isShowingScoreInput: (_states$isShowingScor = states.isShowingScoreInput) !== null && _states$isShowingScor !== void 0 ? _states$isShowingScor : true
      }), isShowingExplanation && /*#__PURE__*/_jsx(AnswerDetailsComponent, {
        question: fillInBlankQuestion,
        answers: answers,
        isSubmissionSubmitted: isSubmissionSubmitted,
        correctAnswerLabel: baseLabel.correctAnswers
      })]
    })
  });
};